import gql from 'graphql-tag';

export const CREATE_OR_UPDATE_ADDRESS = gql`
  mutation createOrUpdateAddress($directoryId: Int!, $address: AddressInputType!) {
    directory {
      createOrUpdateAddress(directoryId: $directoryId, address: $address) {
        id
        address {
          city
          country
          line1
          latitude
          longitude
          postcode
          state
          suburb
        }
        asset {
          assetId
          contentType
          fileName
          s3Key
          type
        }
        description
        directoryType {
          id
          name
        }
        directoryTypeId
        phoneNumber
        tags
        title
        status
        subTitle
        url
      }
    }
  }
`;
